export default __webpack_public_path__ + "static/media/DeleteIcon-red.49f5f509.svg";